import {
  AddressElement,
  CardElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js"
import clsx from "clsx"
import React, { useRef, useState } from "react"
import { axiosInstance, sendPaymentMail } from "../../common/site/utils"
import Recaptcha from "./Recaptcha"

const Payment = ({ reservationData, paymentData, propertyData }) => {
  const { name, surname ,guestName} = reservationData

  const stripe = useStripe()
  const elements = useElements()

  const [isProcessing, setIsProcessing] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")
  const [isSuccess, setIsSuccess] = useState(false)

  const [cardEvent, setCardEvent] = useState(null)

  const [successIDs, setSuccessIDs] = useState(null)

  const recaptchaRef = useRef()

  const handleSubmit = async () => {
    const token = await recaptchaRef.current.executeAsync()

    if (token) {
      setIsProcessing(true)
      setErrorMessage("")

      if (!stripe || !elements) {
        setErrorMessage("Stripe not loaded")
        setIsProcessing(false)
        return
      }

      const addressElement = elements.getElement(AddressElement)
      const addressEvent = await addressElement.getValue()

      if (!addressEvent?.complete) {
        setErrorMessage("Please fill in all address fields")
        setIsProcessing(false)
        return
      }

      const clientData = {
        amount: parseInt(paymentData.totalPrice * 100),
        currency: paymentData.currency,
        description: "Holiday Lettings Booking",
        ...addressEvent.value,
      }

      console.log(
        "🚀 ~ file: Payment.js:39 ~ handleSubmit ~ clientData",
        clientData
      )

      axiosInstance
        .post("/stripe", clientData)
        .then(async res => {
          const clientSecret = res.data

          if (clientSecret) {
            try {
              const paymentInfo = await stripe.confirmCardPayment(
                clientSecret,
                {
                  payment_method: {
                    card: elements.getElement(CardElement),
                  },
                }
              )

              const { error, paymentIntent } = paymentInfo

              if (error) {
                console.error(
                  "🚀 ~ file: Payment.js:46 ~ handleSubmit ~ error",
                  error
                )
                setErrorMessage(error.message)
              } else if (paymentIntent?.status === "succeeded") {
                console.log(
                  "🚀 ~ file: Payment.js:49 ~ handleSubmit ~ paymentIntent",
                  paymentIntent
                )
                setSuccessIDs(prev => ({
                  ...prev,
                  transactionID: paymentIntent.payment_method,
                }))

                reservationData = {
                  ...reservationData,
                  address: clientData.address.line1 || "",
                  postCode: clientData.address.postal_code || "",
                  city: clientData.address.city || "",
                  isoCountryCode: clientData.address.country || "",
                }
                console.log(
                  "🚀 ~ file: Payment.js:82 ~ handleSubmit ~ reservationData",
                  reservationData
                )

                const res = await axiosInstance.post(
                  "/stb-feed-importer/hostaway/setReservation",
                  reservationData
                )
                
                if (res.status === 200) {
                  if (res.data.status === "success") {
                    const bookingCode = res.data.result?.reservationId;
                    const localizatorCode = res.data.result?.hostawayReservationId;

                    setSuccessIDs(prev => ({
                      ...prev,
                      bookingCode,
                      localizatorCode,
                    }))

                    await sendPaymentMail({
                      bookingCode,
                      localizatorCode,
                      reservationData,
                      transactionID: paymentIntent.payment_method,
                      propertyData,
                      amount:
                        paymentData.totalPrice + " " + paymentData.currency,
                    })
                  } else {
                    const errorMsg =
                      res.data.ErrorList?.Error?.[0]?.ErrorMessage
                    setErrorMessage(errorMsg)
                  }
                }

                setIsSuccess(true)
              } else {
                setErrorMessage("Payment failed, please try again")
              }
            } catch (error) {
              console.error(
                "🚀 ~ file: Payment.js:79 ~ handleSubmit ~ error",
                error
              )
            } finally {
              setIsProcessing(false)
            }
          } else {
            setErrorMessage("Payment failed - client secret error")
            console.error(
              "🚀 ~ file: Payment.js:86 ~ handleSubmit",
              "Payment failed - client secret error"
            )
            setIsProcessing(false)
          }
        })
        .catch(err => {
          console.error("🚀 ~ file: Payment.js:156 ~ handleSubmit ~ err:", err)
        })
        .finally(() => {
          setIsProcessing(false)
        })

      recaptchaRef.current.reset()
    } else {
      setErrorMessage("Please verify you are not a robot - reCAPTCHA error")
    }
  }

  return (
    <div className="payment-form-wrap">
      {!isSuccess ? (
        <div className="payment-form">
          <AddressElement
            options={{
              mode: "billing",
              defaultValues: { name: surname },
            }}
          />
          <CardElement
            id="card-element"
            onChange={event => {
              setCardEvent(event)
              console.log(
                "🚀 ~ file: Payment.js:122 ~ Payment ~ cardEvent",
                event
              )
            }}
          />
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <button
            className={clsx("submit-button", isProcessing && "button--loading")}
            onClick={handleSubmit}
            disabled={!stripe || isProcessing}
          >
            <span>Pay Now</span>
          </button>
        </div>
      ) : (
        <div className="success-screen">
          <h2>Payment Successful!</h2>
          <p>Thank you for choosing Arabian Estates.</p>
          <div className="transaction-details">
            {successIDs?.transactionID && (
              <p>
                Transaction ID:{" "}
                <strong>{"  " + successIDs?.transactionID}</strong>
              </p>
            )}
            {successIDs?.bookingCode && (
              <p>
                Booking Code: <strong>{"  " + successIDs?.bookingCode}</strong>
              </p>
            )}
            {successIDs?.localizatorCode && (
              <p>
                Localizator Code:{" "}
                <strong>{"  " + successIDs?.localizatorCode}</strong>
              </p>
            )}
          </div>
        </div>
      )}
      <Recaptcha recaptchaRef={recaptchaRef} />
    </div>
  )
}

export default Payment
